// Monats-Navigation (◀ Juli 2026 ▶) als wiederverwendbarer Baustein — Review-Fund 16.07.: das Markup lag
// bereits 2× in zeiten/ und wäre mit dem Protokoll auf 4 Kopien gewachsen. Neue Verwender nutzen DIESE
// Komponente; `children` hängt weitere Steuerelemente (Filter, Export-Buttons) in dieselbe Zeile.
// (NachweisPanel/MyTimePanel folgen später — bewusst nicht angefasst, solange die Playwright-Baselines
// auf dem Windows-Rechner noch nicht neu festgeschrieben sind.)
import type { ReactNode } from 'react'
import { monthLabel, shiftMonth } from './timeMath'

export function MonthNav({ month, onChange, children }: { month: string; onChange: (next: string) => void; children?: ReactNode }) {
  return (
    <div className="wf-ztnav">
      <button type="button" className="wf-btn wf-btn--ghost wf-btn--sm" aria-label="Voriger Monat" onClick={() => onChange(shiftMonth(month, -1))}>
        ◀
      </button>
      <span className="wf-ztnav__month">{monthLabel(month)}</span>
      <button type="button" className="wf-btn wf-btn--ghost wf-btn--sm" aria-label="Nächster Monat" onClick={() => onChange(shiftMonth(month, 1))}>
        ▶
      </button>
      {children}
    </div>
  )
}
